import Service from './Service';

/**
 * 钱包模块接口
 */
class WalletServiceNew extends Service {
    /**
     * 状态字典码
     */
    getDictList(codeType) {
        return this.axios.get(`api/pay-center/v1/common/dict/list?codeType=${codeType}`);
    }
    /**
     * 查询登录人钱包
     */
    getEnterpriseWallet() {
        return this.axios.get(`api/pay-center/v1/counter/wallet`);
    }
    /**
     * 获取支付类型
     */
    getPayType() {
        return this.axios.get('api/pay-center/v1/common/bizType/list');
    }
    /**
     * 企业钱包账单列表
     */
    queryWalletBillPage(params) {
        return this.axios.get('api/pay-center/v1/counter/wallet/bill/page', { params });
    }
    /**
     * 企业结算宝钱包账单列表
     */
    queryJsbWalletBillPage(params) {
        return this.axios.get('api/pay-center/v1/counter/jsbWallet/bill/page', { params });
    }
    /**
     * 企业钱包当月账单查询
     */
    queryMonthBill(params) {
        return this.axios.get('api/pay-center/v1/counter/wallet/month-bill', { params });
    }
    /**
     * 查询账单详情
     */
    getBillDetail(params) {
        return this.axios.get('api/pay-center/v1/counter/wallet/bill/detail', { params });
    }
    /**
     * 商户列表查询
     */
    getMerchantList(params) {
        return this.axios.get('api/pay-center/v1/counter/merchant/list', { params });
    }
    /**
     * 可用商户列表查询
     */
    getMerchantEnableList() {
        return this.axios.get('api/pay-center/v1/counter/wallet/account-granted-merchant');
    }
    /**
     * 查询钱包账单余额
     */
    getWalletAccountDetail(params) {
        return this.axios.get('api/pay-center/v1/counter/wallet/query/wallet-account/detail', { params });
    }
    /**
     * 查询子账户账单余额
     */
    getsubWalletAccountDetail(params) {
        return this.axios.get('api/pay-center/v1/counter/wallet/query/financing-account/detail', { params });
    }
    /**
     * 查询银联零钱充值信息
     */
    rechIargeInfo(params) {
        return this.axios.get('api/pay-center/v1/counter/wallet/union/recharge-info', { params });
    }
    /**
     * 子账户账单列表
     */
    getsubBillList(params) {
        return this.axios.get('api/pay-center/v1/counter/jsb-financing/bill/page', { params });
    }
    /**
     * 获取钱包详情
     */
    getCounterDetail(params) {
        return this.axios.get('api/pay-center/v1/counter/wallet/query/wallet/detail', { params });
    }
    /**
     * 获取零钱详情
     */
    getUnionDetail(params) {
        return this.axios.get('api/pay-center/v1/counter/wallet/union/account-info', { params });
    }
    /**
     * 钱包充值获取验证码
     */
    withdrawalCode(params) {
        return this.axios.post('api/pay-center/v1/counter/jsb/withdrawal/verification-code',  params );
    }
    /**
     * 获取零钱账单
     */
    getUnionList(params) {
        return this.axios.get('api/pay-center/v1/counter/wallet/union/list', { params });
    }
    /**
     *
     * 月度账单余额信息
     */
    getCreditMonthBill(params) {
        return this.axios.get('api/pay-center/v1/counter/credit/wallet/month-bill', { params });
    }
    /**
     * 授信月度账单列表
     */
    getCreditMonthBillList(params) {
        return this.axios.get('api/pay-center/v1/counter/credit/wallet/month-trade-list', { params });
    }
    /**
     * 授信月度账单授信详情
     */
    getCreditWalletDetail(params) {
        return this.axios.get('api/pay-center/v1/counter/credit/wallet/detail', { params });
    }
    /**
     * 获取授信支付渠道
     */
    getCreditChannel(params) {
        return this.axios.get('api/pay-center/v1/counter/credit/wallet/recharge-channels', { params });
    }
    /**
     * 授信预充值
     */
    creditPreDeposit(params) {
        return this.axios.post('api/pay-center/v1/counter/credit/wallet/preDeposit', params);
    }
    /**
     * 修改银行卡号
     */
    putBankAccount(params) {
        return this.axios.post('api/pay-center/v1/counter/wallet/update/bankcard', params);
    }
    /**
     * 查询银行行名行号
     */
    queryBank(params) {
        return this.axios.get(`api/pay-center/v1/counter/wallet/bankInfo?bankName=${params}`);
    }
    /**
     * 经办人手机号验证码
     */
    postTelephoneCode(params) {
        return this.axios.post(`api/pay-center/v1/counter/wallet/update-commission-mobile/verification-code`, params);
    }
    /**
     * 修改经办人手机号
     */
    putTelephone(params) {
        return this.axios.get(`api/pay-center/v1/counter/wallet/sxbank/update/mobile`, params);
    }
    /**
     * 修改绑定银行卡发送验证码
     */
    bankcardCode(params) {
        return this.axios.post(`api/pay-center/v1/counter/wallet/update/bankcard/verification-code`, params);
    }
    /**
     * 查询充值账户信息查询
     */
    walletRecharge(params) {
        return this.axios.get(`api/pay-center/v1/counter/jsb/recharge`, { params });
    }
    /**
     * 获取支付流水号
     */
    queryPayInfoByBusiSn(params) {
        return this.axios.get(`api/pay-center/v1/counter/payInfo`, { params });
    }
    /**
     * 获取业务流水号
     */
    queryPayInfoByTradeNo(params) {
        return this.axios.get(`api/pay-center/v1/counter/queryPayInfoByTradeNo`, { params });
    }
    /**
     * 支付发送验证码
     */
    paySendSms(params) {
        return this.axios.post(`api/pay-center/v1/counter/pay/send-sms`, params);
    }
    /**
     * 支付
     */
    walletPay(params) {
        return this.axios.post(`api/pay-center/v1/counter/wallet/pay`, params);
    }
    /**
     * 钱包提现查询
     */
    withdrawalQuery(params) {
        return this.axios.get(`api/pay-center/v1/counter/jsb/withdrawal/query`, { params });
    }
    /**
     * 钱包提现
     */
    withdrawal(params) {
        return this.axios.post(`api/pay-center/v1/counter/jsb/withdrawal`, params);
    }
    /**
     * 零钱提现
     */
    asyncWithdrawal(params) {
        return this.axios.post(`api/pay-center/v1/counter/unionChange/withdraw`, params);
    }
    /**
     * 零钱提现验证码
     */
    asyncWithdrawalSms(params) {
        return this.axios.post(`api/pay-center/v1/counter/pay/send-withdraw-sms`, params);
    }
    /**
     * 查询交易手机号
     */
    channelMobile(params) {
        return this.axios.get(`api/pay-center/v1/counter/pay/channel-mobile`, { params });
    }
    /**
     * 获取银联零钱随机因子
     */
    getPlugRandKey() {
        return this.axios.get(`api/pay-center/v1/counter/unionChange/plug-rand-key`);
    }
    /**
     * 关联的商家列表
     */
    getWalletRelation() {
        return this.axios.get(`api/pay-center/v1/counter/wallet/relation`);
    }
    /**
     * 解绑关联企业
     */
    getWalletUnbind(params) {
        return this.axios.post(`api/pay-center/v1/counter/wallet/unbind`,params);
    }
    /**
     * 关联商家查询公司列表
     */
    getOrgInfo(params) {
        return this.axios.get(`api/pay-center/v1/counter/wallet/grant/orgs`,{ params });
    }
    /**
     * 关联商家发送验证码
     */
    sendWalletCode(params) {
        return this.axios.post(`api/pay-center/v1/counter/wallet/grant/verification-code`, params );
    }
    /**
     * 关联商家
     */
    walletBind(params) {
        return this.axios.post(`api/pay-center/v1/counter/wallet/bind`, params );
    }
    /**
     * 登录菜单显示
     */
    walletMenuShow(){
        return this.axios.get(`api/pay-center/v1/counter/wallet/account-merchant`);
    }
    /**
     * 查询钱包经办人信息
     */
    getWalletCommission(params){
        return this.axios.get(`api/pay-center/v1/counter/wallet/sxbank/commission`,{params});
    }
    /**
     * 修改经办人手机号发送验证码
     */
    sendWalletCommissionCode(params) {
        return this.axios.post(`api/pay-center/v1/counter/wallet/sxbank/modify-commission-mobile/verification-code`, params );
    }
    /**
     * 修改钱包手机号
     */
    putWalletphone(params) {
        return this.axios.put(`api/pay-center/v1/counter/wallet/sxbank/mobile`, params);
    }
    /**
     * 查询零钱经办人信息
     */
    getUnionCommission(params){
        return this.axios.get(`api/pay-center/v1/counter/wallet/commission`,{params});
    }
    /**
     * 修改零钱经办人手机号发送验证码
     */
    sendUnionCommissionCode(params) {
        return this.axios.post(`api/pay-center/v1/counter/wallet/modiy-mobile/verification-code`, params );
    }
    /**
     * 修改零钱手机号
     */
    putUnionphone(params) {
        return this.axios.put(`api/pay-center/v1/counter/wallet/mobile`, params);
    }
    /**
     * 开票申请-获取商户列表
     */
    grantMerchantList() {
        return this.axios.get(`api/pay-center/v1/counter/credit/wallet/grant-merchant-list`);
    }
    /**
     * 开票申请列表
     */
    invoiceApplicationsList(params) {
        return this.axios.get(`api/pay-center/v1/counter/wallet/invoice-applications`,{params});
    }
    /**
     * 开票申请详情
     */
    invoiceApplicationsDetail(params) {
        return this.axios.get(`api/pay-center/v1/counter/wallet/invoice-application-detail`,{params});
    }
    /**
     * 开票申请-查询发货列表
     */
    invoiceWalletDeliver(params) {
        return this.axios.get(`api/pay-center/v1/counter/credit/wallet/delivers`,{params});
    }
    /**
     * 开票申请-开票详情关联发货记录
     */
    invoiceApplicationDelivers(params) {
        return this.axios.get(`api/pay-center/v1/counter/wallet/invoice-application-delivers`,{params});
    }
    /**
     * 开票申请-授信发货明细
     */
    invoiceDeliverItems(params) {
        return this.axios.get(`api/pay-center/v1/counter/deliver/items`,{params});
    }
    /**
     * 开票申请-确认开票
     */
    applyDeliverInvoice(params) {
        return this.axios.post(`api/pay-center/v1/counter/wallet/apply-deliver-invoice`,params);
    }
}

const walletServiceNew = new WalletServiceNew();
export default walletServiceNew;
